import styled from 'styled-components'

export const MaintextContainer = styled.div`

p{
    
    font-family: 'Open Sans', sans-serif;
    font-size:14px;
    line-height:20px;
    letter-spacing:0.2px;

}
`;